// ============================================
// ConverseTech Frontend - Mode Selector Component
// ============================================

import { MessageCircle, Code, Users, Trophy } from 'lucide-react';
import type { TrainingMode } from '@conversetech/shared';
import { TRAINING_MODE_LABELS, TRAINING_MODE_DESCRIPTIONS } from '@conversetech/shared';

interface ModeSelectorProps {
  onSelect: (mode: TrainingMode) => void;
}

const MODES: Array<{
  id: TrainingMode;
  testId: string;
  icon: React.ElementType;
}> = [
  { id: 'conversation', testId: 'mode-conversation', icon: MessageCircle },
  { id: 'technical_explanation', testId: 'mode-technical-explanation', icon: Code },
  { id: 'mock_interview', testId: 'mode-mock-interview', icon: Users },
  { id: 'duolingo_test', testId: 'mode-duolingo-test', icon: Trophy },
];

export default function ModeSelector({ onSelect }: ModeSelectorProps) {
  return (
    <div data-testid="mode-selector">
      <h2 className="text-xl font-semibold text-gray-900 mb-6 text-center">
        Choose Training Mode
      </h2>
      <div className="grid md:grid-cols-2 gap-4 max-w-2xl mx-auto">
        {MODES.map(({ id, testId, icon: Icon }) => (
          <button
            key={id}
            data-testid={testId}
            onClick={() => onSelect(id)}
            className="card p-6 text-left hover:border-primary-500 hover:shadow-md transition-all group"
          >
            <div data-testid="mode-icon" className="inline-flex items-center justify-center w-12 h-12 bg-primary-100 text-primary-600 rounded-xl mb-4 group-hover:bg-primary-200">
              <Icon className="w-6 h-6" />
            </div>
            <h3 className="text-lg font-semibold text-gray-900 mb-1">
              {TRAINING_MODE_LABELS[id]}
            </h3>
            <p data-testid="mode-description" className="text-sm text-gray-500">
              {TRAINING_MODE_DESCRIPTIONS[id]}
            </p>
          </button>
        ))}
      </div>
    </div>
  );
}
